import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubmissionDetailsFieldChange } from './submission-details-field-change';
import { SubmissionDetailsFieldChangeTypeEnum } from './submission-details-field-change-type.enum';

@Component({
  selector: 'app-submission-details-field-changes',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './submission-details-field-changes.component.html',
  styleUrls: ['./submission-details-field-changes.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class SubmissionDetailsFieldChangesComponent implements OnChanges {
  @Input() detailsChanges: SubmissionDetailsFieldChange[] = [];
  @Input() changeType!: SubmissionDetailsFieldChangeTypeEnum;

  public label: string = '';
  public hasChanges: boolean = true;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.changeType) {
      this.label =
        this.changeType === SubmissionDetailsFieldChangeTypeEnum.Previous ? $localize`Previous` : $localize`New`;
    }
    if (changes.detailsChanges) {
      this.hasChanges = this.detailsChanges?.some(change => change.hasChanges);
    }
  }

  protected readonly SubmissionDetailsFieldChangeTypeEnum = SubmissionDetailsFieldChangeTypeEnum;
}
